import { createReducer } from "@reduxjs/toolkit";
import {
  TERMS_ERROR,
  TERMS_LIST,
  TERMS_LOADING,
} from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const TermsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(TERMS_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(TERMS_ERROR, (state, { payload }) => {
      state.error = payload;
    })
    .addCase(TERMS_LIST, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    });
});

export default TermsReducer;
